// extracted by mini-css-extract-plugin
export default {"containerA":"Profiles_containerA__O1c6R"};